import { render, staticRenderFns } from "./adminPortalComercial.vue?vue&type=template&id=280b2402"
import script from "./adminPortalComercial.vue?vue&type=script&lang=js"
export * from "./adminPortalComercial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports